import * as React from "react";
import {translate} from 'react-i18next';
import * as _ from "lodash";

// reducer
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";

// semantic
import {Tab, TabProps} from "semantic-ui-react";

import Button from "../../../components/Button";
import Dialog from "../../../components/Dialogs/Dialog";
import PslSelect, {IPSLSel, IPslSelection} from "./PslSelect";
import PslCopy, {ICopyPSL} from "./PslCopy";
import {ModelyearDto, OptionDto, TypefamilyDto} from "../../../services/Client";
import {EActiveMarketKey, PropertiesKey} from "../OptionsViewUtils";

export interface PSLCopyType {
    sourceModelyear: ModelyearDto;
    sourceTypefamily: TypefamilyDto;
    targetModelyear: ModelyearDto;
    targetTypefamily: TypefamilyDto;
}

interface IPslSelectionDialogProps extends ITranslatedComponent {
    /** Call back method for when all information for a PSL are available */
    onPslSelected?: (psl: IPslSelection) => any;

    /** callback method when all copy PSL fields are filled */
    onCopyPsl?: (copyPSL: PSLCopyType) => any;

    onResetWorkflow?: (option: OptionDto) => any;

    onCancel?: () => void;
    userHasBasicMarketCnrAssigned: boolean;
    userHasSpecificCnrsAssigned: boolean;
    isNewGridTable:boolean;
    onNewGridTableChange:(isNewGridTable:boolean)=>void;
}

interface IPslSelectionDialogState {
    /** Selected basic market PSL. */
    selectedBasicMarketPSL: IPSLSel;

    /** Selected specific market PSL. */
    selectedSpecificMarketPSL: IPSLSel;

    /** Selected copy PSL. */
    selectedCopyPSL: ICopyPSL;

    /** currently selected tab */
    activeTab: number | string;
}

class PslSelectionDialog extends React.Component<IPslSelectionDialogProps, IPslSelectionDialogState> {
    constructor(props: IPslSelectionDialogProps) {
        super(props);

        this.state = {
            selectedBasicMarketPSL: {},
            selectedSpecificMarketPSL: {},
            selectedCopyPSL: {},
            activeTab: 0
        };

        this.handleChangeBasicMarket = this.handleChangeBasicMarket.bind(this);
        this.handleChangeSpecificMarket = this.handleChangeSpecificMarket.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.validateCopyInput = this.validateCopyInput.bind(this);
        this.handleCopyChange = this.handleCopyChange.bind(this);
    }

    validateInput(selectedPSL: IPSLSel): boolean {
        const props = ["cnr", "modelyear", "typefamily"];
        let valid = true;
        _.forEach(props, (p) => {
            if (valid && selectedPSL[p] === undefined) {
                valid = false;
            }
        });
        return valid;
    }

    validateCopyInput(selectedCopyPSL: ICopyPSL): boolean {
        const props = ["sourceModelyear", "sourceTypefamily", PropertiesKey.SourceCnrKey, "targetModelyear", "targetTypefamily", PropertiesKey.TargetCnrKey];
        let valid = true;
        _.forEach(props, (p) => {
            if (valid && selectedCopyPSL[p] === undefined) {
                valid = false;
            }
        });
        return valid;
    }

    validateInputInternal = (): boolean => {
        const {selectedBasicMarketPSL, selectedSpecificMarketPSL, selectedCopyPSL, activeTab} = this.state;
        switch (activeTab) {
            case 0:
                return this.validateInput(selectedBasicMarketPSL);
            case 1:
                return this.validateInput(selectedSpecificMarketPSL);
            case 2:
                return this.validateCopyInput(selectedCopyPSL);
            default:
                return false;
        }
    }

    onClickOk = (): void => {

        const {selectedBasicMarketPSL, selectedSpecificMarketPSL, selectedCopyPSL, activeTab} = this.state;
        switch (activeTab) {
            case 0:
                if (this.props.onPslSelected && this.validateInputInternal()) {
                    // @ts-ignore
                    selectedBasicMarketPSL.isNewTable = this.props.isNewGridTable;
                    this.props.onPslSelected(selectedBasicMarketPSL as IPslSelection);
                }
                break;
            case 1:
                if (this.props.onPslSelected && this.validateInputInternal()) {
                     // @ts-ignore
                    selectedSpecificMarketPSL.isNewTable = this.props.isNewGridTable;
                    this.props.onPslSelected(selectedSpecificMarketPSL as IPslSelection);
                }
                break;
            case 2:
                if (this.props.onCopyPsl && this.validateInputInternal()) {
                    this.props.onCopyPsl(selectedCopyPSL as PSLCopyType);
                }
                break;
            default:
                break;
        }
    }

    handleChangeBasicMarket(psl: IPSLSel) {
        this.setState({selectedBasicMarketPSL: psl});
    }

    handleChangeSpecificMarket(psl: IPSLSel) {
        this.setState({selectedSpecificMarketPSL: psl});
    }

    handleCopyChange(copyPSL: ICopyPSL) {
        this.setState({selectedCopyPSL: copyPSL});
    }

    renderLoadBasicMarketPsl = (): JSX.Element => (
        <PslSelect
            value={this.state.selectedBasicMarketPSL}
            onChange={this.handleChangeBasicMarket}
            validateInput={this.validateInput}
            activeMarket={EActiveMarketKey.BasicMarketActiveKey}
            isNewGridTable={this.props.isNewGridTable}
            onNewGridTableChange={this.props.onNewGridTableChange}
        />
    )

    renderLoadSpecificMarketPsl = (): JSX.Element => (
        <PslSelect
            value={this.state.selectedSpecificMarketPSL}
            onChange={this.handleChangeSpecificMarket}
            validateInput={this.validateInput}
            isNewGridTable={this.props.isNewGridTable}
            activeMarket={EActiveMarketKey.SpecificMarketActiveKey}
            onNewGridTableChange={this.props.onNewGridTableChange}
        />
    )

    renderCopyPsl = (): JSX.Element => (
        <PslCopy value={this.state.selectedCopyPSL} onChange={this.handleCopyChange} />
    )

    render() {
        return (
            <Dialog
                open={true}
                title=""
                actions={[
                    <Button
                        key={"submitButton"}
                        icon={"checkmark"}
                        disabled={!this.validateInputInternal()}
                        onClick={this.onClickOk}
                    />,
                    <Button
                        key={"cancelButton"}
                        icon={"ban"}
                        onClick={this.props.onCancel}
                    />
                ]}
            >
                <Tab
                    onTabChange={(event: React.MouseEvent<HTMLDivElement>, data: TabProps) => this.setState({activeTab: data.activeIndex ? data.activeIndex : 0})}
                    panes={[
                        {
                            menuItem: this.props.t("LOAD_PSL_BASIC_MARKET"),
                            render: () => (
                                <Tab.Pane attached={false}>
                                    {this.props.userHasBasicMarketCnrAssigned ? this.renderLoadBasicMarketPsl() : <>{this.props.t("GLOBAL:MISSING_BASIC_MARKET_ACCESS")}</>}
                                </Tab.Pane>
                            )
                        },
                        {
                            menuItem: this.props.t("LOAD_PSL_SPECIFIC_MARKET"),
                            render: () => (
                                <Tab.Pane attached={false}>
                                    {this.props.userHasSpecificCnrsAssigned ? this.renderLoadSpecificMarketPsl() : <>{this.props.t("GLOBAL:MISSING_SPECIFIC_MARKET_ACCESS")}</>}
                                </Tab.Pane>
                            )
                        },
                        {
                            menuItem: this.props.t("COPY_PSL"),
                            render: () => (
                                <Tab.Pane attached={false}>
                                    {this.props.userHasBasicMarketCnrAssigned ? this.renderCopyPsl() : <>{this.props.t("GLOBAL:MISSING_BASIC_MARKET_ACCESS")}</>}
                                </Tab.Pane>
                            )
                        }
                    ]}
                />
            </Dialog>
        );
    }
}

export default translate("OPTIONS_VIEW")(PslSelectionDialog);



// WEBPACK FOOTER //
// ./src/views/OptionsView/PSL/PslSelectionDialog.tsx